
import { useState } from 'react'
import { Grid, Typography, Box, useMediaQuery } from '@mui/material'
import Backdrop from '../components/backdrop-component'
import link from '../../src/assets/img';
import { useTranslate } from 'react-redux-multilingual';
import { useParams } from 'react-router-dom';
import LoadingPageCard from './loading-page-cards';
import DogLoader from '../assets/Loader/Dog.gif'
import { useSelector } from 'react-redux';
import RunScript from './RunScript';

const styles = {
    container: {
        textAlign: "center",
        padding: "20px",
        borderRadius: "10px",
        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
        maxWidth: "600px",
        margin: "20px auto",
    },
    heading: {
        color: "#4CAF50",
        fontSize: "24px",
        margin: "10px 0",
    },
    subheading: {
        color: "#555",
        fontSize: "18px",
        margin: "10px 0",
    },
    list: {
        textAlign: "left",
        margin: "20px auto",
        padding: "0",
        listStyle: "decimal inside",
    },
    listItem: {
        color: "#333",
        fontSize: "16px",
        margin: "10px 0",
    },
}
const LoadingPage = ({ path }) => {
    const store = useSelector((state) => state)
    const [open, setOpen] = useState(false);
    const matches = useMediaQuery('(min-width:500px)');
    let { serviceID } = useParams();
    const t = useTranslate();
    const handleClose = () => setOpen(false);
    const checkCreateUserfailThenstopTheloader = store.globalreducer.checkCreateUserfailThenstopTheloader
    const jodolink = [
        {
            'videotext': t('transformSales'),
            'videolink': link.link1
        },
        {
            'videotext': t('transformSupport'),
            'videolink': link.link2
        },
        {
            'videotext': t('transformCommerce'),
            'videolink': link.link3
        },
    ];

    const jodomeet = [
        {
            'videotext': t('transformSales'),
            'videolink': link.link1
        },
        {
            'videotext': t('transformSupport'),
            'videolink': link.link2
        },
        {
            'videotext': t('transformCommerce'),
            'videolink': link.link3
        },
    ];

    const worldpress = [
        {
            'videotext': t('transformSales'),
            'videolink': link.link1
        },
        {
            'videotext': t('transformSupport'),
            'videolink': link.link2
        },
        {
            'videotext': t('transformCommerce'),
            'videolink': link.link3
        },
    ];

    const jodoteam = [
        {
            'videotext': t('transformSales'),
            'videolink': link.link1,
        },
        {
            'videotext': t('transformSupport'),
            'videolink': link.link2
        },
        {
            'videotext': t('transformCommerce'),
            'videolink': link.link3
        },
    ];

    const jodoindividual = [
        {
            'videotext': t('transformSales'),
            'videolink': link.link1
        },
        {
            'videotext': t('transformSupport'),
            'videolink': link.link2
        },
        {
            'videotext': t('transformCommerce'),
            'videolink': link.link3
        },
    ];

 

    return (
        <>
            <Grid container justifyContent="center" alignContent={'center'} mt="3rem">
                <Grid container spacing={2} justifyContent={'center'}>
                    <RunScript value={2} />
                    {!checkCreateUserfailThenstopTheloader ? <Grid>
                        <Typography align="center" variant='LargeHeading' m={`${matches ? '0 12rem' : '0 5rem'}`} sx={{ whiteSpace: 'pre-line', }}>
                            {`${t('loadingMsgOne')} \n ${t('loadingMsgTwo')}`}
                        </Typography>
                        <Box sx={{ width: '100%', m: '1rem 0px', display: 'flex', justifyContent: 'center', margin: '1rem' }}>
                            <img src={DogLoader} alt="Loading..." />

                        </Box>
                    </Grid>
                        :
                        <Grid>
                            <div>
                                {/* Guidelines steps to access toolbar: */}
                                <div style={styles.container}>
                                    <Typography variant='LargeHeading' > Your Subscription is Being Processed!</Typography>
                                    <Typography variant='LargeHeading' >
                                        Follow these steps to access your toolbar:
                                    </Typography>
                                    <ol style={styles.list}>
                                        <Typography variant='subHeading' >1.Close this tab.</Typography>
                                        <Typography variant='subHeading' >
                                            2. Check your email for a confirmation link from us.
                                        </Typography>
                                        <Typography variant='subHeading' >
                                            3. Click the link to log in and access your Jodo World toolbar.
                                        </Typography>
                                        <Typography variant='subHeading' >
                                            4. If you don’t see the email, check your spam/junk folder.
                                        </Typography>
                                    </ol>
                                </div>
                            </div>
                        </Grid>
                    }
                </Grid>
                {/* loading page for jodolink service */}
                {serviceID.includes('JODOLINK') ? (
                    jodolink.map((item, index) =>
                        <LoadingPageCard key={index} videolink={item.videolink} videotext={item.videotext} />
                    )
                ) :
                    //  loading page for jodomeet service */}
                    serviceID.includes('JODOMEET') ? (
                        jodomeet.map((item, index) =>
                            <LoadingPageCard key={index} videolink={item.videolink} videotext={item.videotext} />
                        )
                    ) :
                        //  loading page for jodoteam service */}
                        serviceID.includes('JODOTEAM') ? (
                            jodoteam.map((item, index) =>
                                <LoadingPageCard key={index} videolink={item.videolink} videotext={item.videotext} />
                            )
                        ) :
                            //  loading page for JODOLINKINDIVIDUAL service */}
                            serviceID.includes('JODOLINKINDIVIDUAL') ? (
                                jodoindividual.map((item, index) =>
                                    <LoadingPageCard key={index} videolink={item.videolink} videotext={item.videotext} />
                                )
                            ) :
                                //  loading page for WORDPRESS service */}
                                serviceID.includes('WORDPRESS') ? (
                                    worldpress.map((item, index) =>
                                        <LoadingPageCard key={index} videolink={item.videolink} videotext={item.videotext} />
                                    )
                                )
                                    : null}

            </Grid>
            {
                open && <Backdrop open={open} handleClose={handleClose} />

            }
        </>
    )
}

export default LoadingPage